<template>
  <div class="szw-row szw-w-full szw-h-19 szw-rounded-lg szw-bg-section-static szw-p-2 szw-gap-2">
    <!-- DATE & STATUS SECTION -->
    <div class="szw-col__center szw-h-17 szw-w-17 szw-justify-center szw-flex-shrink-0 szw-gap-1">
      <span class="szw-h-4 szw-w-10 szw-rounded szw-bg-section-static szw-animate-pulse" />
      <div class="szw-h-4 szw-w-7 szw-rounded szw-bg-section-static szw-animate-pulse" />
    </div>

    <!-- TEAMS & RESULT SECTION -->
    <div class="szw-col szw-gap-2 szw-w-full">
      <!-- TEAM -->
      <div class="szw-row szw-w-full szw-gap-2" v-for="team in 2" :key="team">
        <div class="szw-h-5 szw-w-5 szw-rounded-full szw-bg-section-static szw-animate-pulse" />

        <span class="szw-h-4 szw-w-19 szw-rounded szw-bg-section-static szw-animate-pulse szw-mr-auto" />

        <span :class="['szw-h-4 szw-w-4 szw-rounded szw-bg-section-static szw-animate-pulse']" />
      </div>
    </div>
  </div>
</template>
